module.exports = __webpack_public_path__ + "nobody.4fd914cefb4865b068a3.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/benge/Angular/my-first-app/src/assets/images/nobody.jpg
// module id = ../../../../../src/assets/images/nobody.jpg
// module chunks = main